import script from "./StepMedicalVisit.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepMedicalVisit.vue?vue&type=script&setup=true&lang=ts"

import "./StepMedicalVisit.vue?vue&type=style&index=0&id=a800a60c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a800a60c"]])

export default __exports__